import { LocalRegionType, RegionType } from "graphql/generated";
import { COUNTRY_CODES, CURRENT_COUNTRY } from "src/constants/Countries";
import { checkCountry } from "src/utils/checkCountry";

export const PRODUCT_TYPES = {
  BOTH: "BOTH",
  SUBSCRIPTION: "SUBSCRIPTION",
  ONE_TIME: "ONE_TIME"
};

export const BOOKING_TYPES = {
  DELIVERY: "DELIVERY",
  CONSULT: "CONSULT",
  FERTILITY_COACH: "FERTILITY_COACH"
};

export const DELIVERY_TIME_LIST_ALL: Record<string, Record<string, string>> = {
  [COUNTRY_CODES.SG]: {
    10: "10:00AM – 1:00PM",
    11: "11:00AM – 2:00PM",
    12: "12:00PM – 3:00PM",
    16: "4:00PM – 7:00PM"
  },
  [COUNTRY_CODES.HK]: {
    9: "9:00AM - 11:00AM",
    11: "11:00AM - 1:00PM",
    13: "1:00PM - 3:00PM",
    15: "3:00PM - 5:00PM",
    17: "5:00PM - 7:00PM"
  },
  [COUNTRY_CODES.JP]: {}
};
export const DELIVERY_TIME_LIST = DELIVERY_TIME_LIST_ALL[CURRENT_COUNTRY];

export const IS_GIVEAWAYS_AVAILABLE = process.env.NEXT_PUBLIC_GIVEAWAYS === "true";

export const LOCAL_REGION_LIST: Record<string, Record<string, LocalRegionType>> = {
  [COUNTRY_CODES.SG]: {
    "01": LocalRegionType.SouthCentral,
    "02": LocalRegionType.SouthCentral,
    "03": LocalRegionType.SouthCentral,
    "04": LocalRegionType.SouthCentral,
    "05": LocalRegionType.SouthCentral,
    "06": LocalRegionType.SouthCentral,
    "07": LocalRegionType.SouthCentral,
    "08": LocalRegionType.SouthCentral,
    "09": LocalRegionType.SouthCentral,
    "10": LocalRegionType.SouthCentral,
    "11": LocalRegionType.West,
    "12": LocalRegionType.West,
    "13": LocalRegionType.West,
    "14": LocalRegionType.WestCentral,
    "15": LocalRegionType.SouthCentral,
    "16": LocalRegionType.SouthCentral,
    "17": LocalRegionType.Central,
    "18": LocalRegionType.Central,
    "19": LocalRegionType.Central,
    "20": LocalRegionType.Central,
    "21": LocalRegionType.Central,
    "22": LocalRegionType.Central,
    "23": LocalRegionType.Central,
    "24": LocalRegionType.Central,
    "25": LocalRegionType.Central,
    "26": LocalRegionType.Central,
    "27": LocalRegionType.West,
    "28": LocalRegionType.West,
    "29": LocalRegionType.Central,
    "30": LocalRegionType.Central,
    "31": LocalRegionType.NorthCentral,
    "32": LocalRegionType.Central,
    "33": LocalRegionType.Central,
    "34": LocalRegionType.Northeast,
    "35": LocalRegionType.Northeast,
    "36": LocalRegionType.EastNortheast,
    "37": LocalRegionType.East,
    "38": LocalRegionType.East,
    "39": LocalRegionType.East,
    "40": LocalRegionType.East,
    "41": LocalRegionType.East,
    "42": LocalRegionType.East,
    "43": LocalRegionType.East,
    "44": LocalRegionType.East,
    "45": LocalRegionType.East,
    "46": LocalRegionType.East,
    "47": LocalRegionType.East,
    "48": LocalRegionType.East,
    "49": LocalRegionType.East,
    "50": LocalRegionType.East,
    "51": LocalRegionType.East,
    "52": LocalRegionType.East,
    "53": LocalRegionType.Northeast,
    "54": LocalRegionType.Northeast,
    "55": LocalRegionType.NortheastNorth,
    "56": LocalRegionType.North,
    "57": LocalRegionType.NorthCentral,
    "58": LocalRegionType.West,
    "59": LocalRegionType.West,
    "60": LocalRegionType.West,
    "61": LocalRegionType.West,
    "62": LocalRegionType.West,
    "63": LocalRegionType.West,
    "64": LocalRegionType.West,
    "65": LocalRegionType.West,
    "66": LocalRegionType.West,
    "67": LocalRegionType.West,
    "68": LocalRegionType.West,
    "69": LocalRegionType.West,
    "70": LocalRegionType.West,
    "71": LocalRegionType.West,
    "72": LocalRegionType.North,
    "73": LocalRegionType.North,
    "74": LocalRegionType.North,
    "75": LocalRegionType.North,
    "76": LocalRegionType.North,
    "77": LocalRegionType.North,
    "78": LocalRegionType.North,
    "79": LocalRegionType.NortheastNorth,
    "80": LocalRegionType.NortheastNorth,
    "81": LocalRegionType.East,
    "82": LocalRegionType.Northeast
  },
  [COUNTRY_CODES.HK]: {},
  [COUNTRY_CODES.JP]: {}
};

export const SHOULD_DISPLAY_LANGUAGE_DROPDOWN = checkCountry([RegionType.Hk, RegionType.Jp]);

export const TAX_PERCENT = {
  [COUNTRY_CODES.SG]: 8,
  [COUNTRY_CODES.HK]: 0,
  [COUNTRY_CODES.JP]: 10
};

export const TRANSACTION_FEE_PERCENT = {
  [COUNTRY_CODES.SG]: 3.4,
  [COUNTRY_CODES.HK]: 3.2,
  [COUNTRY_CODES.JP]: 3.5
};

export const CURRENT_TRANSACTION_FEE_PERCENT = TRANSACTION_FEE_PERCENT[CURRENT_COUNTRY];
